<p-panel [header]="header">
    <!-- TODO Fachgebiete sollen per default nicht bearbeitbar sein -> DataDictionary! -->
    <his-multiselect-plam
    	[ddKey]="subjectAreaDdKey"
    	dataSource="subjectAreaValue"
    	[showDropdownIcon]="false"
    	[selectedOptions]="classifications.subjectAreas"
    	(selectedOptionsChange)="onSelectedSubjectAreasChange($event)"
    	field="text"
    	[editMode]="true">
    </his-multiselect-plam>
    
    <his-multiselect-plam
    	[ddKey]="researchAreaKdsfDdKey"
    	dataSource="researchAreaKdsfValue"
    	[selectedOptions]="classifications.researchAreasKdsf"
    	(selectedOptionsChange)="onSelectedResearchAreasKdsfChange($event)"
    	field="text"
    	[editMode]="true">
    </his-multiselect-plam>
    
    <his-multiselect-plam
    	[ddKey]="researchAreaDdKey"
    	dataSource="researchAreaValue"
    	[selectedOptions]="classifications.researchAreas"
    	(selectedOptionsChange)="onSelectedResearchAreasChange($event)"
    	field="text"
    	[editMode]="true">
    </his-multiselect-plam>
</p-panel>
<div class="clearAndSpace"></div>
